import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { AssetIdentifierFormField } from '@/pages/instruments/new-instrument/form-fields/AssetIdentifierFormField'
import { BucketIdField } from '@/pages/instruments/new-instrument/form-fields/BucketIdField'
import { CommentFormField } from '@/pages/instruments/new-instrument/form-fields/CommentFormField'
import { CounterpartyIdField } from '@/pages/instruments/new-instrument/form-fields/CounterpartyIdField'
import { CurrencyIdField } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdField'
import { FundIdField } from '@/pages/instruments/new-instrument/form-fields/FundIdField'
import { ISINField } from '@/pages/instruments/new-instrument/form-fields/ISINField'
import { InitialObservationDateField } from '@/pages/instruments/new-instrument/form-fields/InitialObservationDateField'
import { MaturityDateField } from '@/pages/instruments/new-instrument/form-fields/MaturityDateField'
import { NotionalField } from '@/pages/instruments/new-instrument/form-fields/NotionalField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { SettlementCycleField } from '@/pages/instruments/new-instrument/form-fields/SettlementCycleField'
import { StructureNameField } from '@/pages/instruments/new-instrument/form-fields/StructureNameField'
import { UnderlyingsFormField } from '@/pages/instruments/new-instrument/form-fields/UnderlyingsFormField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { AutocallStandardSchemaType } from '@/pages/instruments/new-instrument/schemas/autocall-standard.schema'

export interface BaseVanillaFormFieldsProps extends React.PropsWithChildren {
  hideAssetIdentifier?: boolean
  maxUnderlyings?: number
}

export const BaseVanillaFormFields: React.FC<BaseVanillaFormFieldsProps> = ({
  maxUnderlyings: _maxUnderlyings,
  hideAssetIdentifier,
  children,
}) => {
  const { trigger } = useFormContext<AutocallStandardSchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-6'}>
      <UnderlyingsFormField maxUnderlyings={1} />
      <FormFieldRow>
        <StructureNameField />
        <CurrencyIdField />
        <CounterpartyIdField />
        <NotionalField />
      </FormFieldRow>
      <FormFieldRow>
        {!hideAssetIdentifier && <AssetIdentifierFormField />}
        <CommentFormField />
        <ISINField />
        <FundIdField />
      </FormFieldRow>
      <FormFieldRow>
        <InitialObservationDateField />
        <MaturityDateField />
        <SettlementCycleField />
        <BucketIdField />
      </FormFieldRow>
      <FormFieldRow>
        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>
      {children}
    </div>
  )
}
